















































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table as DataTable, SvgIcon, Button } from "@brankas/web-ui";
import KYCApplicationStatus from "@/components/kyc-application-status/KYCApplicationStatus.vue";

import {
  ClientListItem,
  TableColumn,
  GetClientListRequest,
  DropdownOption,
} from "@/types";
import { COUNTRY_LIST } from "@/constant";

import SearchInput from "./SearchInput.vue";
import FilterSection from "./FilterSection.vue";
import { ClientState } from "@/stores/modules";
import { kycApplicationType } from "@/utils/client-utils";

const clientModule = namespace("client");

@Component({
  components: {
    DataTable,
    SvgIcon,
    SearchInput,
    FilterSection,
    Button,
    KYCApplicationStatus,
  },
})
export default class ClientList extends Vue {
  @clientModule.Action("getClientList") getClientList!: (
    search?: GetClientListRequest
  ) => ClientListItem[];
  @clientModule.Mutation("setSearchConfig") setSearchConfig!: (
    payload: ClientState["searchConfig"]
  ) => void;
  @clientModule.Mutation("setFilterConfig") setFilterConfig!: (
    payload: ClientState["filterConfig"]
  ) => void;
  @clientModule.Mutation("toggleFilter") toggleFilterMutation!: () => void;
  @clientModule.State("searchConfig")
  searchConfig!: ClientState["searchConfig"];
  @clientModule.State("filterConfig")
  filterConfig!: ClientState["filterConfig"];
  @clientModule.State("page") page!: ClientState["page"];
  @clientModule.State("pageSize") pageSize!: ClientState["pageSize"];
  @clientModule.Mutation("setPage") private readonly setPage!: (
    page: number
  ) => void;
  @clientModule.State("total")
  private readonly total!: number;

  tableColumns: TableColumn[] = [
    {
      label: "ORGANIZATION NAME",
      field: "name",
      sortable: true,
      tdClass: "font-sans font-medium",
    },
    {
      label: "COUNTRY",
      field: "country",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
    {
      label: "ACCESS",
      field: "access",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
    {
      label: "STATUS",
      field: "kycStatus",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
    {
      label: "TRANSACTIONS",
      field: "transactions",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
  ];
  tableData: ClientListItem[] = [];
  searchTargetOptions: DropdownOption[] = [
    {
      value: 1,
      label: "Organization",
    },
    {
      value: 2,
      label: "Email",
    },
  ];
  loading = false;
  search = null;

  // Computed Properties
  get filterField() {
    const countriesOptions = this.countries;

    const accessOptions = [
      { label: "All Environment", value: "all" },
      { label: "Sandbox", value: "sandbox" },
      { label: "Live", value: "live" },
    ];

    const kycStatusOptions = [
      { label: "All Status", value: "all" },
      { label: "Applying for Live", value: kycApplicationType.APPLYING },
      { label: "Not Applying", value: kycApplicationType.NOT_APPLYING },
      { label: "Not Approved", value: kycApplicationType.NOT_APPROVED },
    ];

    const data = [
      {
        name: "countries",
        label: "Countries",
        type: "select",
        options: countriesOptions,
      },
      {
        name: "access",
        label: "Access",
        type: "select",
        options: accessOptions,
      },
      {
        name: "kycApplication",
        label: "KYC Application Status",
        type: "select",
        options: kycStatusOptions,
      },
    ];

    return data;
  }

  get countries() {
    return COUNTRY_LIST;
  }

  get filters() {
    return this.filterConfig.filters;
  }

  set filters(value) {
    this.setFilterConfig({
      ...this.filterConfig,
      filters: value,
    });
  }

  // Methods
  onRowClick(params: any) {
    const data: ClientListItem = params.row;
    this.$router.push(`/client/${data.id}`);
  }

  onPageChange(params: any) {
    this.setPage(params.currentPage);
    this.submitSearch();
  }

  async submitSearch() {
    try {
      this.loading = true;
      const data = await this.getClientList({
        ...this.searchConfig,
        filter: this.filters,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.tableData = data;
    } catch (error) {
      console.error("Failed to get client list");
    } finally {
      this.loading = false;
    }
  }

  async onSearch() {
    this.setSearchConfig(this.search);
    this.onFilter();
  }

  async onFilter() {
    this.setPage(1);
    await this.submitSearch();
  }

  async toggleFilter() {
    this.toggleFilterMutation();
    await this.clearFilter();
  }

  async clearFilter() {
    this.setFilterConfig({
      ...this.filterConfig,
      filters: {
        countries: "",
        access: "all",
        kycApplication: "all",
      },
    });

    await this.submitSearch();
  }

  async mounted() {
    this.search = this.searchConfig;
    await this.submitSearch();
  }
}
